import {useApolloClient} from '@apollo/client';
import {useCallback, useEffect, useRef} from 'react';
import {toast} from 'sonner';
import {BulkCloseProgressToast} from './BulkCloseProgressToast';
import {
  useBulkCloseActions,
  useBulkCloseRun,
  useConfigureBulkClose,
} from './useBulkClose';

const TOAST_ID = 'conversations-bulk-close';
const COMPLETE_DISMISS_MS = 4000;

export const BulkCloseToaster = () => {
  const client = useApolloClient();
  const {dismiss} = useBulkCloseActions();
  const shownJobId = useRef<string | null>(null);
  const handleComplete = useCallback(() => {
    client
      .refetchQueries({
        include: [
          'listConversationsLight',
          'AllConversationCounts',
          'FindFullConversation',
        ],
      })
      .catch(() => {});
  }, [client]);

  useConfigureBulkClose(client, handleComplete);

  const run = useBulkCloseRun();

  useEffect(() => {
    if (run && shownJobId.current !== run.jobId) {
      shownJobId.current = run.jobId;
      toast.custom(id => <BulkCloseProgressToast toastId={id} />, {
        id: TOAST_ID,
        duration: Infinity,
      });
    }
    if (!run && shownJobId.current !== null) {
      shownJobId.current = null;
      toast.dismiss(TOAST_ID);
    }
  }, [run]);

  useEffect(() => {
    if (!run || (run.status !== 'COMPLETED' && run.status !== 'FAILED')) {
      return;
    }
    const timer = setTimeout(() => {
      toast.dismiss(TOAST_ID);
      dismiss();
    }, COMPLETE_DISMISS_MS);
    return () => clearTimeout(timer);
  }, [run, dismiss]);

  return null;
};
